import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

// 权限校验（与后端一致）：companyOnly=仅机构管理员；companyOrUnit=管理员/战队长；companyOrTeam=管理员/战队长/小组组长；leaderOnly=管理员/队长/unit/team
function checkPrivilege(meta) {
  if (!meta) return true
  const user = store.state.user
  if (meta.companyOnly) {
    return !!(user && user.type === 'company')
  }
  if (meta.companyOrUnit) {
    return !!(user && (user.type === 'company' || user.type === 'unit'))
  }
  if (meta.companyOrTeam) {
    return !!(user && (user.type === 'company' || user.type === 'unit' || user.type === 'team'))
  }
  if (meta.leaderOnly) {
    if (!user) return false
    if (user.type === 'company' || user.type === 'unit' || user.type === 'team') return true
    return user.type === 'staff' && parseInt(user.is_leader) === 1
  }
  return true
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    // 客户签署落地页（免登录）
    path: '/sign/:agreementId',
    name: 'customer-sign',
    component: () => import('@/views/CustomerSign.vue'),
    meta: { title: '协议签署' }
  },
  {
    // 名额申请/兼职表对外预览页（免登录，催单分享链接）
    path: '/preview/:type',
    name: 'preview-page',
    component: () => import('@/views/PreviewPage.vue'),
    meta: { title: '预览' }
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '工作台', icon: 'el-icon-data-board' }
      },
      // 线索管理
      { path: 'lead/list', name: 'lead-list', component: () => import('@/views/LeadList.vue'), meta: { title: '线索列表', icon: 'el-icon-user' } },
      // 订单管理
      { path: 'order/console', name: 'order-console', component: () => import('@/views/OrderConsole.vue'), meta: { title: '订单工作台', icon: 'el-icon-data-board' } },
      { path: 'order/list', name: 'order-list', component: () => import('@/views/OrderList.vue'), meta: { title: '订单列表', icon: 'el-icon-tickets' } },
      { path: 'order/add', name: 'order-add', component: () => import('@/views/OrderAdd.vue'), meta: { title: '新建订单', icon: 'el-icon-circle-plus-outline' } },
      // 收款管理
      { path: 'bill/list', name: 'bill-list', component: () => import('@/views/BillList.vue'), meta: { title: '账单业绩', icon: 'el-icon-money' } },
      { path: 'installment/list', name: 'installment-list', component: () => import('@/views/InstallmentList.vue'), meta: { title: '分期管理', icon: 'el-icon-coin' } },
      { path: 'refund/list', name: 'refund-list', component: () => import('@/views/RefundList.vue'), meta: { title: '退款管理', icon: 'el-icon-refresh' } },
      // 协议管理
      { path: 'agreement/list', name: 'agreement-list', component: () => import('@/views/AgreementList.vue'), meta: { title: '协议列表', icon: 'el-icon-document' } },
      { path: 'agreement/template', name: 'agreement-template', component: () => import('@/views/TemplateList.vue'), meta: { title: '模板管理', icon: 'el-icon-document-copy', companyOnly: true } },
      // 统计分析
      { path: 'stats/index', name: 'stats-index', component: () => import('@/views/StatsIndex.vue'), meta: { title: '统计分析', icon: 'el-icon-data-analysis' } },
      { path: 'stats/analysis', name: 'stats-analysis', component: () => import('@/views/StatsAnalysis.vue'), meta: { title: '数据分析', icon: 'el-icon-pie-chart', companyOnly: true } },
      // 工具（含 Excel 导入/短信群发占位）
      { path: 'tools/import', name: 'tools-import', component: () => import('@/views/ImportExcel.vue'), meta: { title: 'Excel 导入', icon: 'el-icon-upload2' } },
      { path: 'tools/sms', name: 'tools-sms', component: () => import('@/views/SmsSend.vue'), meta: { title: '短信群发', icon: 'el-icon-message', leaderOnly: true } },
      { path: 'tools/quote', name: 'tools-quote', component: () => import('@/views/QuoteList.vue'), meta: { title: '名额申请表', icon: 'el-icon-tickets' } },
      { path: 'tools/work', name: 'tools-work', component: () => import('@/views/WorkList.vue'), meta: { title: '兼职表', icon: 'el-icon-suitcase' } },
      // 组织架构（仅机构管理员）
      { path: 'org/index', name: 'org-index', component: () => import('@/views/OrgIndex.vue'), meta: { title: '主体信息', icon: 'el-icon-office-building', companyOnly: true } },
      { path: 'org/unit', name: 'org-unit', component: () => import('@/views/UnitList.vue'), meta: { title: '战队管理', icon: 'el-icon-s-grid', companyOnly: true } },
      { path: 'org/team', name: 'org-team', component: () => import('@/views/TeamList.vue'), meta: { title: '小组管理', icon: 'el-icon-s-operation', companyOrUnit: true } },
      { path: 'org/staff', name: 'org-staff', component: () => import('@/views/StaffList.vue'), meta: { title: '员工管理', icon: 'el-icon-s-custom', companyOrTeam: true } },
      // 基础数据（仅机构管理员）
      { path: 'base/product', name: 'base-product', component: () => import('@/views/ProductList.vue'), meta: { title: '商品管理', icon: 'el-icon-shopping-bag-1', companyOnly: true } },
      { path: 'base/paytype', name: 'base-paytype', component: () => import('@/views/PaytypeList.vue'), meta: { title: '收款平台', icon: 'el-icon-credit-card', companyOnly: true } },
      { path: 'base/channel', name: 'base-channel', component: () => import('@/views/ChannelList.vue'), meta: { title: '来源渠道', icon: 'el-icon-link', companyOnly: true } },
      // 续费充值（仅机构管理员）
      { path: 'recharge/index', name: 'recharge-index', component: () => import('@/views/RechargeIndex.vue'), meta: { title: '续费充值', icon: 'el-icon-coin', companyOnly: true } }
    ]
  },
  { path: '*', redirect: '/dashboard' }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 全局守卫：未登录跳登录页；无权限跳工作台
router.beforeEach((to, from, next) => {
  document.title = (to.meta && to.meta.title) ? `${to.meta.title} · crm.fun` : 'crm.fun'
  const token = store.state.token || localStorage.getItem('crm_token')
  // 客户签署落地页：免登录
  if (to.name === 'customer-sign') {
    // 若已登录机构账号，不干扰；直接放行（该页自行加载免登录接口）
    return next()
  }
  // 名额申请/兼职表对外预览页：免登录
  if (to.name === 'preview-page') {
    return next()
  }
  if (to.path === '/login') {
    return token ? next('/dashboard') : next()
  }
  if (!token) return next('/login')
  // 角色权限校验
  if (!checkPrivilege(to.meta)) return next('/dashboard')
  next()
})

export default router
